import { useEffect } from 'react';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { useHashRoute } from './hooks/useHashRoute';
import { Home } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';

function App() {
  const path = useHashRoute();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    const base = 'Grow With Call – Business Communication Solutions';
    if (path === '/privacy') document.title = `Privacy Policy | ${base}`;
    else if (path === '/terms') document.title = `Terms of Service | ${base}`;
    else document.title = base;
  }, [path]);

  const page =
    path === '/privacy' ? (
      <PrivacyPolicy />
    ) : path === '/terms' ? (
      <TermsOfService />
    ) : (
      <Home />
    );

  return (
    <div className="min-h-dvh">
      <Navbar path={path} />
      {page}
      <Footer />
    </div>
  );
}

export default App;
